// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__35iWv","content":"styles_content__fvE1c","selectAll":"styles_selectAll__2DUb6"};